import styled from 'styled-components';

export const FormFieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    * {
      pointer-events: none;
    }
  }
`;
